import React, { useState } from "react";
import { FormGroup, Input, Label, Button } from "reactstrap";

const PartnerInfoForm = props => {
  const [name, setName] = useState(props.name || "");
  const [description, setDescription] = useState(props.description || "");

  const onNameInput = e => {
    setName(e.target.value);
  };

  const onDescriptionInput = e => {
    setDescription(e.target.value);
  };

  const onSubmit = () => {
    if (name.length) {
      const payload = createPayload();
      props.onSubmit(payload).then(() => {
        setName("");
        setDescription("");
      });
    }
  };

  const onKeyPress = e => {
    if (e.charCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      props.onSubmit();
    }
  };

  const createPayload = () => {
    return {
      name: name || null,
      description: description || null
    };
  };

  return (
    <React.Fragment>
      <FormGroup>
        <Label htmlFor="partner name">Partner Name (required)</Label>
        <Input
          type="text"
          // id="add-category-input"
          value={name}
          onKeyPress={onKeyPress}
          onChange={onNameInput}
        />
        <Label style={{ marginTop: 10 }} htmlFor="partner name">
          Partner Description
        </Label>

        <Input
          type="text"
          // id="add-category-input"
          value={description}
          onKeyPress={onKeyPress}
          onChange={onDescriptionInput}
        />
      </FormGroup>
      <Button
        style={{ float: "right" }}
        type="submit"
        color="primary"
        onClick={onSubmit}
        disabled={!name.length}
      >
        {props.isSubmitting && (
          <i
            className="fa fa-circle-o-notch fa-spin"
            style={{ marginRight: 5 }}
          />
        )}
        Submit
      </Button>
    </React.Fragment>
  );
};

export default PartnerInfoForm;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/PartnerInfoForm.js